// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__7CBL+","modal":"style_modal__sD5IT","title":"style_title__wrQf6","overlay_close":"style_overlay_close__aXoEK"};